export default "__VITE_ASSET__D3F2wXZo__"